/**
 * Stringから半角・全角数字以外の文字を排除する
 *
 * @param {string} input - フィルターをかける文字列
 * @returns {string} - フィルタリングされた文字列で、数字のみを含む
 */
export const filterNonNumeric = (input: string) => {
  return input.replace(/[^0-9０-９]/g, "");
};
